import React from 'react';

import JsFileDownloader from 'js-file-downloader';
import { useDispatch } from 'react-redux';

import Icon from 'components/shared/Icon';
import Download from 'components/shared/Icon/icons/Download';
import Visibility from 'components/shared/Icon/icons/Visibility';
import Text from 'components/shared/Typography/Text';
import { useSnackbar } from 'hooks/useSnackbar';
import { wrapper } from 'middlewares/generator/wrapper';
import { openModalAction } from 'store/assets';
import { openSelector } from 'store/assets/selectors';
import { ASSET_TYPE_VIEW } from 'store/assets/types';

import s from './index.module.css';
import { IDocumentItemProps, IState } from './types';

const isClosedSelector = (state: IState) => openSelector(state) === null;

function DocumentItem({ doc }: IDocumentItemProps) {
  const dispatch = useDispatch();
  const onSnackbar = useSnackbar();
  const handleViewClick = () =>
    dispatch(
      wrapper(async function* (dispatch: (fn: any) => void, getState: () => any) {
        dispatch(openModalAction({ type: ASSET_TYPE_VIEW, settings: doc, options: { hasTags: false } }));

        yield async () => isClosedSelector(getState());
      }),
    );

  const handleDownloadClick = async () => {
    try {
      await new JsFileDownloader({ url: doc.url, filename: doc.filename });
      onSnackbar(`The file '${doc.filename}' was downloaded.`);
    } catch {
      onSnackbar(`'${doc.filename}' couldn't be downloaded. Please try again.`, true);
    }
  };

  return (
    <div className={s.docItem}>
      <div className={s.docItemNameWrapper}>
        <Text className={s.docItemName}>{doc.name}</Text>
      </div>
      <div className={s.docItemActions}>
        <Icon className={s.eye} component={Visibility} onClick={handleViewClick} />
        <Icon className={s.download} component={Download} onClick={handleDownloadClick} />
      </div>
    </div>
  );
}

export default DocumentItem;
